// Routing

import { marginTop16, paddingTop16 } from "@/components/Styles"
// Custom Components
import CustomerPermissions, {
  INTERNAL_DONATIONS_ENABLED,
} from "@/components/utils/CustomerPermissions"
import { useCustomer } from "@/hooks/reduxHooks"
import { Button } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"

function DonateNavigationButton() {
  const customer = useCustomer()

  return (
    <div className="grow flex-center" style={paddingTop16}>
      {customer.showExternalDonations ? (
        <Button
          component="a"
          href={customer.donationOutsideLink}
          id="support-logged-out"
          style={marginTop16}
        >
          {`Support ${customer.name}`}
        </Button>
      ) : (
        <CustomerPermissions allowedIf={INTERNAL_DONATIONS_ENABLED}>
          <Button component={RouterLink} id="support-logged-out" style={marginTop16} to="/donate">
            {`Support ${customer.name}`}
          </Button>
        </CustomerPermissions>
      )}
    </div>
  )
}

export default DonateNavigationButton
